import { RouteRecordRaw } from "vue-router";

/**
 * 获取class类的第一个参数
 */
export type GetInstanceFirstParam<T extends new(...args: any[]) => any> = T extends (new(opt: infer R, ...args: any[]) => any) ? R : never;

/**
 * 获取函数第一个参数
 */
export type GetFunctionFirstParam<T extends (...any: any[]) => any> = T extends ((opt: infer R, ...any: any[]) => any) ? R : never;


/**
 * 获取promise返回类型
 */
export type GetPromiseType<T extends Promise<any>> = T extends Promise<infer R> ? R : never;

/**
 * 获取Api对应的类型
 */
export type GetApiDataType<T extends ((...args: any[]) => Promise<any>)> = T extends ((...args: any[]) => Promise<infer R>) ? R : never;

/**
 * 获取数组内的函数类型
 */
export type GetArrayApiType<T extends ((...args: any[]) => Promise<any>)> = T extends ((...args: any[]) => Promise<Array<infer R> | null>) ? R : never;


/**
 * 活动相关场景
 */
export enum ActivityScene {
    Activity = 1,
    SheetActivity = 2,
    // 滑动效果(通常用于个人设置，个人中心)
    SlideLeftActivity = 4,
    SlideRightActivity = 5,
    // 弹出效果(通常用于活动弹窗,建议使用pinia管理初始化数据)
    ModalCenterActivity = 3,
    FlipYAcvitity = 6,
    FlipXAcvitity = 7,
    // 正常淡入淡出(某些情况下不需要特殊样式)
    FadeActivity = 8,
  }
  
  /**
   * 路由原格式
   */
  export type RouteRecordRawMeta = RouteRecordRaw & {
    name: string;
    meta: {
      /**
       * 页面标题
       */
      title: string;
      /**
       * 需要埋点的页面需要这个值，没有这个值整个事件行为不上报
       */
      pageName: string;
      /**
       * 过渡场景
       */
      scene: ActivityScene,
      /**
       * 替换地址
       */
      replaceUrl?: string;
      /**
       * 是否是首个路由
       */
      isHomeRoute: boolean;
    },
    children?: Array<RouteRecordRawMeta>;
  }
  

  export default {
    ActivityScene,
  };